export class ZPlayNetworkService {

    static TOKEN_KEY: string;
    static REFRESH_TOKEN_KEY: string;

    public static xhrMultipartUpload = async (url: string, file: any, progressCallback?: any) => {

        return new Promise(function (resolve, reject) {

            const xhr = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(xhr);
                    } else {
                        reject(xhr);
                    }
                }
            };

            if (progressCallback) {
                xhr.upload.onprogress = (e) => {
                    if (e.lengthComputable) {
                        let percentComplete = (e.loaded / file.size) * 100;
                        progressCallback(Math.round(percentComplete));
                    }
                };
            }

            xhr.open("PUT", url);
            xhr.setRequestHeader("Content-Type", file.type);
            xhr.send(file);
        });

    }

    public static putMultipartUpload = (url: string, file: any, callback: any, errorCallback: any) => {

        fetch(url, {
            method: "PUT",
            mode: "cors",
            headers: {
                "Content-Type": "application/octet-stream",
            },
            body: file
        })
            .then(data => callback(data))
            .catch(err => errorCallback(err));
    };

    public static postEmptyResponse = (url: string, body: any, callback: any, errorCallback: any) => {
        fetch(url, {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem(ZPlayNetworkService.TOKEN_KEY || "token") || "",
                "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify(body)
        })
            .then(data => {
                if (data.status >= 400 && data.status <= 599)
                    errorCallback(data.status)
                else
                    callback()
            })
            .catch(err => errorCallback(err));
    };

    public static putEmptyResponse = (url: string, body: any, callback: any, errorCallback: any) => {
        fetch(url, {
            method: "PUT",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem(ZPlayNetworkService.TOKEN_KEY || "token") || "",
                "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify(body)
        })
            .then(data => {
                if (data.status >= 400 && data.status <= 599)
                    errorCallback(data.status)
                else
                    callback()
            })
            .catch(err => errorCallback(err));
    };

    public static post = (url: string, body: any, callback: any, errorCallback: any) => {

        fetch(url, {

            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem(ZPlayNetworkService.TOKEN_KEY || "token") || "",
                "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify(body)
        })
            .then(async response => { let status = response.status; return { response: await response.json(), status: status } })
            .then(data => {
                if (data.status >= 400 && data.status <= 599)
                    errorCallback(data.response)
                else
                    callback(data.response)
            })
            .catch(err => errorCallback(err));
    };

    public static put = (url: string, body: any, callback: any, errorCallback: any) => {
        fetch(url, {
            method: "PUT",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem(ZPlayNetworkService.TOKEN_KEY || "token") || "",
                "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify(body)
        })
            .then(async response => { let status = response.status; return { response: await response.json(), status: status } })
            .then(data => {
                if (data.status >= 400 && data.status <= 599)
                    errorCallback(data.response)
                else
                    callback(data.response)
            })
            .catch(err => errorCallback(err));
    };

    public static unauthorizedPostEmptyResponse = (url: string, body: any, callback: any, errorCallback: any) => {

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify(body)
        })
            .then(data => callback(data))
            .catch(err => errorCallback(err));

    };

    public static unauthorizedPutEmptyResponse = (url: string, body: any, callback: any, errorCallback: any) => {

        fetch(url, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify(body)
        })
            .then(data => callback(data))
            .catch(err => errorCallback(err));

    };

    public static unauthorizedPost = (url: string, body: any, callback: any, errorCallback: any) => {

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify(body)
        })
            .then(async response => { let status = response.status; return { response: await response.json(), status: status } })
            .then(data => {
                if (data.status >= 400 && data.status <= 599)
                    errorCallback(data.response)
                else
                    callback(data.response)
            })
            .catch(err => errorCallback(err));

    };

    public static unauthorizedGet = (url: string, queryParams: string[], callback: any, errorCallback: any) => {

        fetch(url, {
            method: "GET",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            }
        })
            .then(async response => { let status = response.status; return { response: await response.json(), status: status } })
            .then(data => {
                if (data.status >= 400 && data.status <= 599)
                    errorCallback(data.response)
                else
                    callback(data.response)
            })
            .catch(err => errorCallback(err));

    };

    private static isNotBlank(value: string) {
        return value !== null && value !== undefined && value !== ""
    }

    public static get = (url: string, callback: any, errorCallback: any, queryParams: Array<[string, any]> | null = null) => {

        if (queryParams) {

            url += "?"

            for (let i = 0; i < queryParams!.length; i++) {

                if (queryParams[i] && this.isNotBlank(queryParams[i][0]) && this.isNotBlank(queryParams[i][1])) {

                    let param = queryParams[i][0] + "=" + queryParams![i][1]

                    if (i !== queryParams.length - 1)
                        param += "&"

                    url += param;
                }
            }

            if (url.charAt(url.length) === "&")
                url = url.substring(0, url.length - 1);
        }

        fetch(url, {
            method: "GET",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem(ZPlayNetworkService.TOKEN_KEY || "token") || "",
                "Access-Control-Allow-Origin": "*"
            }
        })
            .then(async response => { let status = response.status; return { response: await response.json(), status: status } })
            .then(data => {
                if (data.status >= 400 && data.status <= 599)
                    errorCallback(data.response)
                else
                    callback(data.response)
            })
            .catch(err => errorCallback(err));

    };

    public static promiseGet = async (url: string, queryParams: string[] | null = null) => {

        const response = await fetch(url, {
            method: "GET",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem(ZPlayNetworkService.TOKEN_KEY || "token") || "",
                "Access-Control-Allow-Origin": "*"
            }
        });

        const json = await response.json();

        return json;
    }

    public static deleteEmptyResponse = (url: string, callback: any, errorCallback: any, queryParams: Array<[string, any]> | null = null) => {

        if (queryParams) {
            let params: string = "?"

            for (let i = 0; i < queryParams!.length; i++) {
                params += queryParams[i][0] + "=" + queryParams![i][1]
                if (queryParams!.length !== i + 1)
                    params += "&"
                url += params
                params = ""
            }

        }

        fetch(url, {
            method: "DELETE",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem(ZPlayNetworkService.TOKEN_KEY || "token") || "",
                "Access-Control-Allow-Origin": "*"
            }
        })
            .then(data => {
                if (data.status >= 400 && data.status <= 599)
                    errorCallback(data.status)
                else
                    callback()
            })
            .catch(err => errorCallback(err));
    }

    public static delete = (url: string, callback: any, errorCallback: any, queryParams: Array<[string, any]> | null = null) => {

        if (queryParams) {
            let params: string = "?"

            for (let i = 0; i < queryParams!.length; i++) {
                params += queryParams[i][0] + "=" + queryParams![i][1]
                if (queryParams!.length !== i + 1)
                    params += "&"
                url += params
                params = ""
            }

        }
        fetch(url, {
            method: "DELETE",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem(ZPlayNetworkService.TOKEN_KEY || "token") || "",
                "Access-Control-Allow-Origin": "*"
            }
        })
            .then(async response => { let status = response.status; return { response: await response.json(), status: status } })
            .then(data => {
                if (data.status >= 400 && data.status <= 599)
                    errorCallback(data.response)
                else
                    callback(data.response)
            })
            .catch(err => errorCallback(err));

    };
}
